import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=3c4982f4&scoped=true&"
import script from "./TableCell.vue?vue&type=script&lang=ts&"
export * from "./TableCell.vue?vue&type=script&lang=ts&"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=3c4982f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4982f4",
  null
  
)

export default component.exports